import React from 'react';
import { CloseCircleRed } from '../../../common/icons/CloseCircleRed';
import { Calendar } from '../../../common/icons/Calendar';
import DatePicker from 'react-datepicker';
import { IDatePickerDateRange } from '../../../@types/datePicker';
import {
  CalendarIconContainer,
  InputContainer,
  MyAuditDatePickerContainer,
} from '../../sharedStyledComponents/Datepicker.styled';
import { castSelectedDateWithoutConversion } from '../../../../helpers/dates';

export function DatePickerDateRange ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: IDatePickerDateRange) {
  return (
    <MyAuditDatePickerContainer>
      <InputContainer>
        <DatePicker
          className={`myaudit-filter-date-picker`}
          popperClassName="date-picker-popper"
          dateFormat="dd-MM-yyyy"
          onFocus={(event) => event.target.blur()}
          placeholderText="Start Date"
          selected={startDate && new Date(startDate)}
          onChange={(selectedDate) => {
            const date = castSelectedDateWithoutConversion(selectedDate);
            setStartDate(date);
          }}
          maxDate={endDate}
        />
        <CalendarIconContainer>
          {startDate ? (
            <CloseCircleRed onClick={() => setStartDate(undefined)} />
          ) : (
            <Calendar />
          )}
        </CalendarIconContainer>
      </InputContainer>
      <InputContainer>
        <DatePicker
          className={`myaudit-filter-date-picker`}
          popperClassName="date-picker-popper"
          dateFormat="dd-MM-yyyy"
          minDate={startDate && new Date(startDate)}
          onFocus={(event) => event.target.blur()}
          placeholderText="End Date"
          selected={endDate && new Date(endDate)}
          onChange={(selectedDate) => {
            const date = castSelectedDateWithoutConversion(selectedDate);
            setEndDate(date);
          }}
        />
        <CalendarIconContainer>
          {endDate ? (
            <CloseCircleRed onClick={() => setEndDate(undefined)} />
          ) : (
            <Calendar />
          )}
        </CalendarIconContainer>
      </InputContainer>
    </MyAuditDatePickerContainer>
  );
}
